export default __webpack_public_path__ + "static/media/682.d3c45901.gif";